export default {"src":"/pro/_next/static/media/axs.05443d0a.svg","height":1000,"width":1000,"blurWidth":0,"blurHeight":0};